export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REFRESH = 'AUTH_REFRESH';
export const AUTH_AUTHENTICATE = 'AUTH_AUTHENTICATE';
export const AUTH_AUTHENTICATE_LINKEDIN = 'AUTH_AUTHENTICATE_LINKEDIN';
export const AUTH_AUTHENTICATE_GOOGLE = 'AUTH_AUTHENTICATE_GOOGLE';
export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_VERIFY_EMAIL = 'AUTH_VERIFY_EMAIL';
export const AUTH_REQUEST_PASSWORD_CHANGE = 'AUTH_REQUEST_PASSWORD_CHANGE';
export const AUTH_CHANGE_PASSWORD = 'AUTH_CHANGE_PASSWORD';
export const USER_UPGRADE = 'USER_UPGRADE'
export const USER_CARD_INFO = 'USER_CARD_INFO'
export const USER_ERROR = 'USER_ERROR';
export const USER_SUCCESS = 'USER_SUCCESS';

export const CAMPAIGN_REQUEST = 'CAMPAIGN_REQUEST';
export const CAMPAIGN_CREATE = 'CAMPAIGN_CREATE';
export const CAMPAIGN_GET_LIST = 'CAMPAIGN_GET_LIST';
export const CAMPAIGN_GET = 'CAMPAIGN_GET';
export const CAMPAIGN_SUCCESS = 'CAMPAIGN_SUCCESS';
export const CAMPAIGN_ERROR = 'CAMPAIGN_ERROR';
export const CAMPAIGN_SET_NEW = 'CAMPAIGN_SET_NEW';
export const CAMPAIGN_SEND_CONTACT = 'CAMPAIGN_SEND_CONTACT';
export const CAMPAIGN_SEARCH_CONTACTS = 'CAMPAIGN_SEARCH_CONTACTS';
export const CAMPAIGN_GET_STATS = 'CAMPAIGN_GET_STATS';
export const CAMPAIGN_ADD_PROSPECTS = 'CAMPAIGN_ADD_PROSPECTS'

export const TEMPLATE_REQUEST = 'TEMPLATE_REQUEST';
export const TEMPLATE_CREATE = 'TEMPLATE_CREATE';
export const TEMPLATE_GET_LIST = 'TEMPLATE_GET_LIST';
export const TEMPLATE_GET = 'TEMPLATE_GET';
export const TEMPLATE_SUCCESS = 'TEMPLATE_SUCCESS';
export const TEMPLATE_ERROR = 'TEMPLATE_ERROR';
export const TEMPLATE_SET_CURRENT = 'TEMPLATE_SET_CURRENT';

export const LINK_REQUEST = 'LINK_REQUEST';
export const LINK_CREATE = 'LINK_CREATE';
export const LINK_GET_LIST = 'LINK_GET_LIST';
export const LINK_SUCCESS = 'LINK_SUCCESS';
export const LINK_ERROR = 'LINK_ERROR';
